<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/vehicleBlack/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width"
        label-width="100px">
        <el-form-item label="车牌号" prop='vehicleKey'>
          <el-input clearable v-model="searchForm.vehicleKey" placeholder="车牌号" />
        </el-form-item>
        <el-form-item label="司机姓名" prop='driverName'>
          <el-input clearable v-model="searchForm.driverName" placeholder="司机姓名" />
        </el-form-item>
        <el-form-item label="司机身份证" prop='driverKey'>
          <el-input clearable v-model="searchForm.driverKey" placeholder="司机身份证" />
        </el-form-item>
        <el-form-item label="司机手机号" prop='driverMobile'>
          <el-input clearable v-model="searchForm.driverMobile" placeholder="司机手机号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="车牌号" prop="vehicleKey"></el-table-column>
        <el-table-column min-width="120" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="180" label="司机身份证" prop="driverKey"></el-table-column>
        <el-table-column min-width="120" label="司机手机号" prop="driverMobile"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="备注"
          prop="remark"></el-table-column>
        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text"
                @click="$router.push('/vehicleBlack/detail?blacklistId=' + row.blacklistId)">详情</el-button>
              <el-button type="text" v-if="hasEdit"
                @click=" $router.push('/vehicleBlack/edit?blacklistId=' + row.blacklistId)">编辑</el-button>
              <el-button class="del-btn" type="text" v-if="hasDelete" @click="deleteRow(row.blacklistId)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'VehicleBlackList',
  mixins: [keepAlive],
  data() {
    return {
      activeName: '0',
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        vehicleKey: '',
        driverName: '',
        driverKey: '',
        driverMobile: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.vehicleBlack.selectWlVehicleBlacklistByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    deleteRow(blacklistId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.vehicleBlack.deleteDataWlVehicleBlacklist, {
          blacklistId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>
